export class IlluminationProperties {
  public specularShininess: number;
  public diffuseCoefficient: number;
  public specularCoefficient: number;

  public clone(): IlluminationProperties {
    const cloned = new IlluminationProperties();
    cloned.specularShininess = this.specularShininess;
    cloned.diffuseCoefficient = this.diffuseCoefficient;
    cloned.specularCoefficient = this.specularCoefficient;

    return cloned;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/IlluminationProperties.ts